export interface Pagination {
  itemsPerPage: number;
  maxSize: number;
}

export class PaginationConstant implements Pagination {
  itemsPerPage = 10;
  maxSize = 3;
}
